import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setE] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setL] = useState(false);
  const [failedOnce, setFailedOnce] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setL(true);
    try {
      await login(email, pw);
      toast.success("Welcome back!");
      nav("/profiles");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Login failed";
      toast.error(detail);
      setFailedOnce(true);
    } finally { setL(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/profiles";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      <img src="https://images.unsplash.com/photo-1759842952767-456f1b6dded8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400" className="absolute inset-0 w-full h-full object-cover opacity-40" alt="" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/80 via-[#0A0A0A]/85 to-[#0A0A0A]" />
      <header className="relative z-10 px-6 lg:px-12 py-6">
        <Link to="/" className="text-[#E50914] font-black text-2xl">CINECINEMA</Link>
      </header>
      <main className="relative z-10 max-w-md mx-auto px-6 py-12">
        <div className="bg-black/70 backdrop-blur-xl rounded-lg p-10 border border-white/5 shadow-2xl">
          <h1 className="text-3xl font-bold mb-6">Sign In</h1>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="login-email" type="email" required placeholder="Email address" className="input-dark" value={email} onChange={(e) => setE(e.target.value)} />
            <input data-testid="login-password" type="password" required placeholder="Password" className="input-dark" value={pw} onChange={(e) => setPw(e.target.value)} />
            <button data-testid="login-submit" disabled={loading} className="btn-red w-full py-3 rounded font-semibold mt-2">
              {loading ? "Signing in..." : "Sign In"}
            </button>
            <div className="text-right">
              <Link
                to="/forgot-password"
                data-testid="forgot-password-link"
                className="text-xs text-gray-400 hover:text-[#E50914] underline-offset-2 hover:underline transition-colors"
              >
                Forgot password?
              </Link>
            </div>
          </form>
          <div className="flex items-center gap-3 my-6 text-gray-500 text-sm">
            <div className="flex-1 h-px bg-white/10" /> OR <div className="flex-1 h-px bg-white/10" />
          </div>
          <button data-testid="google-login-btn" onClick={googleLogin} className="w-full bg-white text-black py-3 rounded font-semibold hover:bg-gray-200 transition-colors flex items-center justify-center gap-2">
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <p className="mt-8 text-gray-400 text-sm">
            New to CineCinema? <Link to="/signup" className="text-white hover:underline">Sign up now.</Link>
          </p>
          {failedOnce && (
            <div
              data-testid="login-recovery-hint"
              className="mt-5 p-4 bg-amber-500/[0.06] border border-amber-500/25 rounded-md text-xs text-amber-100/85 leading-relaxed"
            >
              <div className="font-semibold text-amber-300 mb-1.5">Locked out? Try these:</div>
              <ul className="space-y-1 ml-1">
                <li>• <Link to="/forgot-password" className="underline hover:text-white">Forgot password?</Link> — emails a one-time reset link</li>
                <li>• <button type="button" onClick={googleLogin} className="underline hover:text-white">Sign in with Google</button> — using the same email auto-links to your account</li>
                <li>• Last resort: ask the admin to send you a reset link from the Users panel</li>
              </ul>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
